
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.155 0v3.077h-1.54A4.734 4.734 0 000 7.692v27.693A4.734 4.734 0 004.615 40h30.77A4.734 4.734 0 0040 35.385V7.692a4.734 4.734 0 00-4.615-4.615h-1.538V0H30.77v3.077H9.23V0zm-1.54 6.154h1.538V9.23H9.23V6.154h21.537V9.23h3.077V6.154h1.538a1.453 1.453 0 011.537 1.363 1.278 1.278 0 010 .175v4.615H3.078V7.692A1.452 1.452 0 014.44 6.154a1.7 1.7 0 01.175 0zm-1.537 9.23h33.844v19.995a1.452 1.452 0 01-1.362 1.538 1.7 1.7 0 01-.175 0H4.615a1.453 1.453 0 01-1.537-1.363 1.278 1.278 0 010-.175zm9.229 3.077v3.076h3.078v-3.075zm6.155 0v3.076h3.075v-3.075zm6.154 0v3.076h3.078v-3.075zm6.155 0v3.076h3.077v-3.075zM6.155 24.614v3.079H9.23v-3.079zm6.154 0v3.079h3.076v-3.079zm6.155 0v3.079h3.072v-3.079zm6.154 0v3.079h3.076v-3.079zm6.155 0v3.079h3.079v-3.079zM6.155 30.769v3.078H9.23v-3.078zm6.154 0v3.078h3.076v-3.078zm6.155 0v3.078h3.072v-3.078z"}})])
          )
        }
      }
    